import {Typography,} from "@mui/material";
import {ViewPopup} from "components/Admin/Pages/ViewPopup/ViewPopup";
import React from "react";
import {Label} from "../../../components/Label/Label";
import {seasonService} from "../../../services/seasonService";
import dayjs from "dayjs";

export const SeasonView = () => {
  return (
    <ViewPopup
      query={seasonService.getById}
    >
      {(record) => (
        <>
          <Typography
            variant="body1"
            sx={{fontWeight: "bold"}}
            gutterBottom
          >
            <Label label="startDate"/>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {dayjs(record.startDate).format("DD.MM.YYYY")}
          </Typography>
        </>
      )}
    </ViewPopup>
  );
};
